import { composeFieldPath } from '@northfork/basics'
import { MvtBasisSelection } from '../../mvt-basis.model'
import { InventoryType } from '../../inventory-type.model'
export const directTransferField = composeFieldPath(
  [] as BulkDirectTransferRow[],
)

export interface BulkDirectTransferRow {
  rowId: string
  rowNumber?: string
  entryDate: string
  assetId: string
  sourceAccountId: string
  destAccountId: string
  units: string
  balanceUnits?: number
  inventoryType?: string
  marketPrice: string
  mvtBasisSelection: MvtBasisSelection[]
  mvtBasisSelectionText: string
  validityStatus: 'valid' | 'invalid' | 'warning' | 'inactive' | 'intermediate'
  errorMessageMap: Map<string, string[]>
  legacyOrigTranId?: number
  collateralBroker?: string
  securityId?: number
  transferSpecificLotId?: string
  orderId?: string
  transactionBasis?: string
  basisId?: number
}

export interface ErrorMessageRow {
  field: string
  errorMessages: string[]
}

export interface PriceInputInfoTransferCreate {
  accountId: number
  entryDate: string
  cusip: string
  inventoryType?: string
  collateralBroker?: string
}

export interface OrigUnitsRequest {
  rowId: number
  accountId: number
  cusip: string
  entryDate: string
  inventoryType?: InventoryType
  collateralBroker?: string
  lotEntryTranId?: number
}

export interface OrigUnitsResponse {
  tranDetails: {
    [key: string]: {
      pricingData: {
        price: number
        securityId: number
      }
      balanceUnits: number
    }
  }
}
